window.NavigationToggler = {
  listen() {
    return $(document).on('click', '[data-toggle-sidenav]', e => {
      const name = $(e.target).closest('[data-toggle-sidenav]').data('toggle-sidenav');
      return this.toggleNavigation(name);
    });
  },

  toggleNavigation(value) {
    const name = ((value !== $('body').data('sidenav')) || ($('body').data('sidenav') === '')) ? value : '';

    $('body').attr('data-sidenav', name);
    $('body').data('sidenav', name);
    if (value === 'expanded') {
      $(document).trigger('sidebar-toggled');
      if ($(window).width() > 1024) {
        return this.setNavigationCookie(value === name ? 1 : 0);
      }
    }
  },

  setNavigationCookie(value) {
    return $.cookie('sidenav-expanded', value, { expires: 999, path: '/' });
  }
};
